import React from 'react';
import Banner from "./Banner/Banner";
import Forma from "./Forma/Forma";
const Main = () => {
    return (
        <div>
            <Banner />
            <Forma  />
        </div>
    );
};

export default Main;